import * as React from 'react';
import { FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import { Translate } from '../../../../../../shared/LanguageService';
import { IEmailSender } from '../../Types';
import FormSelect from '../../../../../../components/common/FormSelect';

interface IProps {
    onChange: (e: any) => void;
    senders: IEmailSender[];
    sender: number;
    errors: any;
}

const SenderSelect = (props: IProps) => {
    function errorExists(errors: any, key: string) {
        if (errors && errors[key]) {
            return true;
        }

        return false;
    }

    return (
        <FormGroup
            className="required"
            validationState={errorExists(props.errors, 'sender') ? 'error' : null}
        >
            <ControlLabel>
                {Translate('view-order/basic-order/modal/create-email/form/from/label')}
            </ControlLabel>
            <FormSelect
                name="sender"
                required
                value={props.sender as any}
                onChange={props.onChange}
                defaultTranslateKey="view-order/basic-order/modal/create-email/form/from/placeholder"
            >
                {props.senders.map((s: IEmailSender) => {
                    return (
                        <option key={s.id} value={s.id as any}>
                            {Translate(s.displayNameTranslationKey) +
                                ` <${s.emailAddresses[0].address}>`}
                        </option>
                    );
                })}
            </FormSelect>
            {props.errors && <HelpBlock>{props.errors.sender}</HelpBlock>}
        </FormGroup>
    );
};

export default SenderSelect;
